import { BrokerOfficeListResponse } from '@/entity/BrokerOffice';
import { BrokerOfficeListSchema } from '@/types/structuredData';
import { PATHS } from '@/constants';

const BASE_URL = process.env.BASE_URL;

export const generateBrokerOfficeListSchema = (
  data: BrokerOfficeListResponse,
): BrokerOfficeListSchema => {
  const itemListElement: BrokerOfficeListSchema['itemListElement'] = data.objects.map(
    (office, index) => {
      const phone = office.phone;
      const telephone = phone?.telUri ?? phone?.formatted ?? undefined;

      return {
        '@type': 'ListItem' as const,
        position: index + 1,
        item: {
          '@type': 'Organization' as const,
          name: office.name || '',
          url: `${BASE_URL}/${PATHS.BROKERS}/${office.directLink ?? office.slug}`,
          telephone,
          email: office.email || undefined,
          address:
            office.address || office.zip || office.town
              ? {
                  '@type': 'PostalAddress' as const,
                  streetAddress: office.address || undefined,
                  addressLocality: office.town || undefined,
                  postalCode: office.zip || undefined,
                  addressCountry: 'AT',
                }
              : undefined,
        },
      };
    },
  );

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: itemListElement.length > 0 ? itemListElement : undefined,
  };
};
